import "flowbite";
import DateRangePicker from "flowbite-datepicker/js/DateRangePicker";
import Toastify from "toastify-js";
import { delay } from "../js/utils";

const filterAssessmentResults = () => {
  // setup up datepickers
  const dateRangePickerEl = document.getElementById("assessmentDateRange");
  if (dateRangePickerEl) {
    // optional options with default values and callback functions
    const options = {
      defaultDatepickerId: null,
      autohide: false,
      format: "yyyy/mm/dd",
      maxDate: null,
      minDate: null,
      orientation: "bottom",
      buttons: false,
      autoSelectToday: false,
      title: null,
      rangePicker: false,
      onShow: () => {},
      onHide: () => {},
    };

    const instanceOptions = {
      id: "assessmentDateRange",
      override: true,
    };

    new DateRangePicker(dateRangePickerEl, { options, instanceOptions });
  }

  //format date
  const formatTimestamp = (timestamp) => {
    console.log(timestamp);
    const date = new Date(timestamp);
    const day = date.getDate();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const period = date.getHours() >= 12 ? "pm" : "am";
    return `${day}/${month}/${year} (${hours}:${minutes}${period})`;
  };

  // get the form
  let form = document.getElementById("filter_assessments");

  // check if the form exists in the DOM
  if (form) {
    // create submit event listener
    form.addEventListener("submit", (ev) => {
      // Prevent form submission
      ev.preventDefault();

      // show loader
      document.getElementById("loading").classList.remove("hidden");

      // Get form data
      const data = new FormData(form);
      data.append("action", "filter_assessments");
      console.log([...data]);
     //return;

      // Make the AJAX request
      fetch("/wp-admin/admin-ajax.php", { method: "POST", body: data })
        .then((response) => response.json())
        .then((response) => {
          console.log(response.data);
          if (response.data.success) {
            delay(1000).then(() => {
              document.getElementById("assessmentResultCount").textContent =
                response.data.resultCount;
              document.getElementById("assessmentBody").innerHTML = JSON.parse(
                response.data.results
              );
              document.getElementById("loading").classList.add("hidden");
            });
          } else {
            Toastify({
              text: "Something went wrong...",
              duration: 2000,
              gravity: "bottom", // `top` or `bottom`
              position: "right", // `left`, `center` or `right`,
              className: "rounded-md shadow",
              style: { background: "#000000" },
            }).showToast();
          }
        })
        .catch((error) => {
          // Handle any errors
          console.error(error);
        });
    });
  }
};

export { filterAssessmentResults };
